import React from 'react';
import PropTypes from 'prop-types';
import { CiCalendar } from "@react-icons/all-files/ci/CiCalendar";

const WeekNumber = ({ className = '', week, iconClassName = '' }) => {
  return (
    <div className={`dui-flex dui-items-center dui-gap-2 ${className}`}>
      <CiCalendar className={`dui-w-8 dui-h-8 ${iconClassName}`} />
            Week {week}
    </div>
  );
};
WeekNumber.propTypes = {
  week: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default WeekNumber;